import imagesLoaded from 'imagesloaded';
class MouseCarousel {
  constructor() {
    // Activate at 768px ($bp-tablet-xl)
    this.mq = window.matchMedia('(min-width:768px)');
    this.carousel = document.querySelector('.js-mouse-carousel');

    // Setup carousel if not mobile
    if (this.mq.matches && this.carousel) {
      this.setupCarousel();
    }

    // Observer window width change
    new ResizeObserver(() => this.handleResize()).observe(document.body);
  }

  handleResize() {
    if (this.mq.matches && this.carousel) {
      this.setupCarousel();
    } else {
      this.destroyCarousel();
    }
  }

  setupCarousel() {
    imagesLoaded('.js-mouse-carousel', () => {
      this.carouselContent = this.carousel.querySelector('.ai-work-preview__items');
      this.carouselWidth = this.carousel.offsetWidth;
      this.carouselContentWidth = this.carouselContent.scrollWidth;
      this.overflow = this.carouselContentWidth - this.carouselWidth;

      // Bind event
      this.carousel.addEventListener('mousemove', e => this.onMouseMove(e));
    });
  }

  onMouseMove(e) {
    // Left of browser maps to translateX(0)
    // Right side of browser maps to translateX(-this.overflow);
    const xFromLeftFrac = e.clientX / this.carouselWidth;
    const xShiftPx = xFromLeftFrac * this.overflow;
    this.carouselContent.style.transform = `translateX(${-xShiftPx}px)`;
  }

  destroyCarousel() {
    if (this.carousel) {
      this.carousel.removeEventListener('mousemove', this.onMouseMove);
      this.carousel.style.transform = `translateX(0)`;
    }
  }
}

export default MouseCarousel;
